import React from 'react'
import CandidateFormTab from './candidate-form-tab'

const CandidateForm = () => {
    return (
        <div>
            <CandidateFormTab />
        </div>
    )
}

export default CandidateForm
